"use client";

import dynamic from "next/dynamic";

const VideoPreview = dynamic(() => import("./VideoPreview"), {
  loading: () => (
    <div className="mx-auto my-12 aspect-video w-full max-w-[956px] animate-pulse rounded bg-gray-100" />
  ),
});

export default VideoPreview;
